<!--
 * @Author: Latte
 * @Date: 2022-01-11 14:05:25
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-17 15:42:27
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\videoCourse\videoDetail\videoComment.vue
-->
<template>
  <div>
    <!-- 内容 -->
    <el-table
        :data="videoCommentList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column type="expand">
        <template #default="scope">
          <el-table v-if="scope.row.commentFileList.length >0" :data="scope.row.commentFileList">
            <el-table-column prop="videoCommentFileID" label="#" align="center"></el-table-column>
            <el-table-column label="文件">
              <template #default="scope">
                <div style="width: 100px; height: 100px;position: relative">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down"
                            :src="getPreviewImageUrl(scope.row)" lazy :preview-src-list="[getPreviewImageUrl(scope.row)]"
                            :close-on-click-modal="true">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <i class="el-icon-video-play"
                     v-if="scope.row.fileType === 1"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                     @click.stop="previewVideo(scope.row)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="liveCommentFileId" label="上传时间" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>
          </el-table>
          <p v-else>没有文件数据</p>
        </template>
      </el-table-column>
      <el-table-column
          prop="videoCommentID"
          label="#"
          align="center"
          width="100"
      />
      <el-table-column
          label="评论者"
          align="center"
          prop="nickname"
          width="200"
      >
      </el-table-column>
      <el-table-column
          prop="content"
          label="评论内容"
          align="center"
          show-overflow-tooltip
      />
      <!-- <el-table-column
        prop="replyCount"
        label="回复数"
        align="center"
        width="100"
      /> -->
      <el-table-column
          prop="likeCount"
          label="点赞数"
          align="center"
          width="100"
      />
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="primary"
              @click.stop="openReplyVideoCommentListDialog(scope.row)"
          >
            查看回复
          </el-button>
          <el-button
              size="small"
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              @click.stop="deleteOrBackVideoComment(scope.row)"
          >
            {{ scope.row.isDeleted ? "恢复" : "删除" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
        v-show="totalCount > pageSize"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
    />

    <el-dialog
        title="评论回复"
        :visible.sync="replyVideoCommentListDialog"
        width="60%"
    >
      <!-- 内容 -->
      <el-table
          :data="replyVideoCommentList"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px;height: 60vh;overflow: auto"
      >
        <el-table-column type="expand">
          <template #default="scope">
            <el-table v-if="scope.row.commentFileList.length >0" :data="scope.row.commentFileList">
              <el-table-column prop="videoCommentFileID" label="#" align="center"></el-table-column>
              <el-table-column label="文件">
                <template #default="scope">
                  <div style="width: 100px; height: 100px;position: relative">
                    <el-image style="width: 100px; height: 100px;" fit="scale-down"
                              :src="getPreviewImageUrl(scope.row)" lazy :preview-src-list="[getPreviewImageUrl(scope.row)]"
                              :close-on-click-modal="true">
                      <template #error>
                        <p></p>
                      </template>
                    </el-image>
                    <i class="el-icon-video-play"
                       v-if="scope.row.fileType === 1"
                       style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                       @click.stop="previewVideo(scope.row)"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="liveCommentFileId" label="上传时间" align="center">
                <template #default="scope">
                  {{ scope.row.createTime | formatDateTime }}
                </template>
              </el-table-column>
            </el-table>
            <p v-else>没有文件数据</p>
          </template>
        </el-table-column>
        <el-table-column prop="videoCommentID" label="#" align="center"/>
        <el-table-column prop="nickname" label="评论者" align="center"/>
        <el-table-column
            prop="content"
            label="评论内容"
            align="center"
            show-overflow-tooltip
        />
        <el-table-column label="评论时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
                size="small"
                :type="scope.row.isDeleted ? 'warning' : 'danger'"
                @click.stop="deleteOrBackVideoComment(scope.row)"
            >
              {{ scope.row.isDeleted ? "恢复" : "删除" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          v-show="replyTotalCount > replyPageSize"
          background
          layout="prev, pager, next"
          :total="replyTotalCount"
          :page-size="replyPageSize"
          :current-page="replyCurrentPage"
          @current-change="replyCurrentChange"
      />
    </el-dialog>

    <el-dialog :visible.sync="previewVideoDlg" :destroy-on-close="true">
      <tx-video-player style="height: 60vh" :video-url="previewVideoUrl"></tx-video-player>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVideoCommentList,
  deleteOrBackVideoComment,
  getReplyVideoCommentList
} from "@/api/videoDetail";
import {
  printObj
} from "@/utils/debug"
import {
  handleRes
} from "@/utils/handleRes"
import {getCloudUrl, getPreviewImgUrl} from "@/utils/urlutil";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";

export default {
  name: "videoComment",
  components: {TxVideoPlayer},
  props: {
    videoID: {
      type: Number,
    },
  },

  data() {
    return {
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      videoCommentList: [], // 视频评论列表
      replyVideoCommentListDialog: false, // 视频评论回复列表开关
      replyVideoCommentList: [], // 视频评论回复列表
      replyTotalCount: 0,
      replyPageSize: 10,
      replyCurrentPage: 1,
      videoCommentID: 0,//查看恢复的CommentID

      previewVideoDlg:false,
      previewVideoUrl:""
    };
  },

  activated() {
    this.getVideoCommentList();
  },

  deactivated() {
  },

  beforeDestroy() {
  },

  destroyed() {
  },

  methods: {
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getVideoCommentList();
    },
    replyCurrentChange(currentPage) {
      this.replyCurrentPage = currentPage
      this.getReplyVideoCommentList()
    },
    /**
     * 获取视频评论列表
     */
    getVideoCommentList() {
      const params = {
        videoID: this.videoID,
        // sortName: '',
        // sortOrder: '',
        pageNumber: this.currentPage || 1,
        pageSize: this.pageSize || 10,
        keyWord: "",
        where: "",
      };
      getVideoCommentList(params).then((res) => {
        this.videoCommentList = res.data.rows;
        this.totalCount = res.data.total;
      });
    },
    /**
     * 打开评论回复对话框
     *
     * @param {object} row 所选对象信息
     */
    openReplyVideoCommentListDialog(row) {
      this.replyVideoCommentListDialog = true;
      this.replyCurrentPage = 1
      this.videoCommentID = row.videoCommentID
      this.getReplyVideoCommentList()
    },
    getReplyVideoCommentList() {
      getReplyVideoCommentList({
        pageSize: this.replyPageSize,
        pageNumber: this.replyCurrentPage,
        relativeCommentId: this.videoCommentID,
        videoId: this.videoID
      }).then(res => {
        handleRes(res, () => {
          this.replyTotalCount = res.data.total
          this.replyVideoCommentList = res.data.rows
        })
      })
    },
    /**
     * 删除/恢复视频评论
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackVideoComment(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该评论";
        tips2 = "恢复成功!";
      } else {
        tips1 = "是否删除该评论";
        tips2 = "删除成功";
      }
      const params = {
        videoCommentID: row.videoCommentID,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            deleteOrBackVideoComment(params).then(() => {
              this.$message({
                type: "success",
                message: tips2,
              });
              // console.log("isReply " + row.isReply)
              if (row.isReply) {
                this.getReplyVideoCommentList()
              } else {
                this.getVideoCommentList();
              }

            });
          })
    },
    getPreviewImageUrl(entity){
      return getPreviewImgUrl(entity)
    },
    previewVideo(entity){
      this.previewVideoUrl = getCloudUrl(entity.fileUrl)
      this.previewVideoDlg = true
    }
  },
};
</script>


<style scoped>
</style>
